import { xor } from 'lodash';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { navigateToChangeInsightDetails } from '../../links/index.jsx';

const EmployeesFilter = ({
  initiativeParticipations,
  selectedEmployeeIdsIds,
  initiativeId,
  initiativeType,
}) => {
  const selectedCount = selectedEmployeeIdsIds.length;

  const handleSelect = useCallback(
    (employeeId) => {
      // Handle numeric IDs and special 'none' value
      if (!employeeId || employeeId === 'none') {
        return navigateToChangeInsightDetails(
          {
            employeeIds: xor(selectedEmployeeIdsIds, ['none']),
          },
          initiativeId,
          initiativeType
        );
      }

      const numericId = parseInt(employeeId, 10);
      return navigateToChangeInsightDetails(
        {
          employeeIds: xor(selectedEmployeeIdsIds, [numericId]),
        },
        initiativeId,
        initiativeType
      );
    },
    [selectedEmployeeIdsIds, initiativeId, initiativeType]
  );

  const renderMenuItem = useCallback(
    (status) => {
      const isActive = selectedEmployeeIdsIds.includes(
        status.id === 'none' ? 'none' : status.id
      );

      return (
        <React.Fragment key={status.id}>
          <MenuItem
            active={isActive}
            eventKey={status.id.toString()}
            onSelect={handleSelect}
          >
            <span className={status.archived ? 'text-muted' : ''}>
              {status.fullName}
            </span>
          </MenuItem>
        </React.Fragment>
      );
    },
    [selectedEmployeeIdsIds]
  );

  return (
    <div className="" style={{ flex: 1 }}>
      <div className="text-muted filter-label">Employees</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="statuses-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {[...initiativeParticipations, { id: 'none', fullName: 'None' }].map(
            renderMenuItem
          )}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
};

EmployeesFilter.defaultProps = {
  initiativeParticipations: [],
  selectedEmployeeIdsIds: [],
};

export default EmployeesFilter;
